import cognito from '../config/client_cognito.json' assert { type: 'json' };

export class LocalStorageHandler {
  private static userId = '';

  static setUser(userId: string): void {
    this.userId = userId;
  }

  private static getCognitoLastAuthUser(): void {
    this.userId =
      localStorage.getItem(`CognitoIdentityServiceProvider.${cognito.userPoolWebClientId}.LastAuthUser`) ?? '';
  }

  static getUser(): string {
    if (!this.userId) this.getCognitoLastAuthUser();
    return this.userId;
  }

  static save<T = string>(key: string, value?: any): T {
    if (value === null || typeof value === 'undefined') {
      localStorage.removeItem(key);
      return value;
    }
    if (typeof value === 'object') {
      // An empty collection carries no information, so drop the key rather
      // than storing '[]' / '{}' — a reader then sees "nothing stored" and
      // falls back to its default, which is the same outcome with less junk
      // left behind. The early returns matter: without them the removeItem
      // calls below were immediately undone by the setItem that followed.
      const isEmptyArray = Array.isArray(value) && !value.length;
      const isEmptyPlainObject = !Object.keys(value).length
        && Object.getPrototypeOf(value) === Object.prototype;
      if (isEmptyArray || isEmptyPlainObject) {
        localStorage.removeItem(key);
        return value;
      }
      localStorage.setItem(key, JSON.stringify(value));
      return value;
    }

    localStorage.setItem(key, value);
    return value;
  }

  private static isJsonString(str: string | null): any {
    if (!str) return str;
    try {
      return JSON.parse(str);
    } catch {
      return str;
    }
  }

  static get<T = string>(key: string): T {
    return this.isJsonString(localStorage.getItem(key)) ?? null;
  }
}
